
import APIRequest from './APIRequest';

export default APIRequest;



// WEBPACK FOOTER //
// ./src/API/APIRequest/index.js